import React from "react";
import "./index.css";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const maxVisiblePages = 9; // Number of visible pages
    const pageNumbers = [];

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total pages are <= maxVisiblePages
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Handle ellipses and limited pages
      if (currentPage <= 5) {
        // Show first few pages and ellipsis at the end
        for (let i = 1; i <= 6; i++) pageNumbers.push(i);
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      } else if (currentPage > totalPages - 5) {
        // Show ellipsis at the start and last few pages
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = totalPages - 5; i <= totalPages; i++) pageNumbers.push(i);
      } else {
        // Show ellipsis at both ends with current page in the middle
        pageNumbers.push(1);
        pageNumbers.push("...");
        for (let i = currentPage - 2; i <= currentPage + 2; i++)
          pageNumbers.push(i);
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  return (
    <div className="pagination">
      <button
        className="page-item prev"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>

      <div className="page-numbers">
        {getPageNumbers().map((page, index) => (
          <button
            key={index}
            className={`page-item ${currentPage === page ? "active" : ""} ${
              page === "..." ? "ellipsis" : ""
            }`}
            onClick={() => typeof page === "number" && onPageChange(page)}
            disabled={page === "..."}
          >
            {page}
          </button>
        ))}
      </div>

      <button
        className="page-item next"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );
};

export default Pagination;
